<template>
    <div class="w-full flex flex-wrap mx-auto -px-2" v-if="ready">
        <div class="w-full hidden lg:block px-2 lg:w-1/5">
            <div class="flex justify-center">
                <nav id="nav" class="w-56 relative">
                    <span
                        class="absolute h-10 w-full bg-white rounded-lg shadow ease-out transition-transform transition-medium"
                        :style="{
                            transform: `translateY(calc(100% * ${selected}))`,
                        }"
                    ></span>
                    <ul class="relative">
                        <template v-for="link in links">
                            <li v-if="link.show" :key="link.category_id">
                                <button
                                    type="button"
                                    @click="select(link.index)"
                                    :aria-selected="selected === link.index"
                                    class="py-2 px-3 w-full flex items-center focus:outline-none focus-visible:underline"
                                >
                                    <i
                                        :class="[
                                            selected === link.index
                                                ? 'text-indigo-500'
                                                : 'text-gray-500',
                                            link.icon,
                                        ]"
                                        class="h-6 w-6 transition-all ease-out transition-medium"
                                        style="
                                            font-size: 22px;
                                            line-height: 26px;
                                        "
                                    ></i>
                                    <span
                                        :class="
                                            selected === link.index
                                                ? 'text-black'
                                                : 'text-gray-700'
                                        "
                                        class="ml-4 text-sm font-medium transition-all ease-out transition-medium"
                                        >{{ link.title }}</span
                                    >
                                </button>
                            </li>
                        </template>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="w-full lg:w-4/5 px-2">
            <router-view :key="$route.fullPath"></router-view>
        </div>
    </div>
</template>

<script>
import Sidebar from "./sidebar";

export default {
    components: {
        Sidebar,
    },

    data() {
        return {
            selected: 0,
            categories: [],
            links: [],
            ready: false,
        };
    },

    methods: {
        select(index) {
            this.selected = index;
            this.$router.push(
                this.links.find((link) => link.index === index).route
            );
        },

        async fetchCategories() {
            await axios
                .get("/admin/products/categories/all", {
                    params: {
                        "filters[parent]": 1,
                    },
                })
                .then((response) => {
                    this.categories = response.data.data;
                });

            this.categories.forEach((category) => {
                if (category.is_subscriptions) {
                    return;
                }

                this.links.push({
                    title: category.name,
                    category_id: category.id,
                    route: {
                        name: "admin.products.index",
                        query: {
                            category: category.id,
                        },
                    },
                    icon: category.icon,
                    index: null,
                    show: this.can("manage-products"),
                });
            });

            if (
                !this.$route.query.category &&
                this.$route.name.includes("index")
            ) {
                this.$router.push(this.links[0].route);
            }

            this.setSelectedLink();

            this.ready = true;
        },

        setSelectedLink() {
            let vm = this;
            let index = 0;
            this.links.forEach(function (link) {
                if (link.show == true) {
                    link.index = index;
                    index++;
                }

                if (link.category_id == vm.$route.query.category) {
                    vm.selected = link.index;
                }
            });
        },
    },

    mounted() {
        this.fetchCategories();
    },

    watch: {
        $route(to, from) {
            if (
                !this.$route.query.category &&
                this.$route.name.includes("index")
            ) {
                this.$router.push(this.links[0].route);
                this.setSelectedLink();
            }
        },
    },
};
</script>